import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { BootstrapGate } from "./modules/bootstrap";
import ThemeProvider from "./theme";
import { Router } from "./routes";
import { configureStore } from "./redux";

// Styles
import "./App.css";
import { SnackbarProvider } from "./components";

const { persistor, store } = configureStore();

function App() {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <BootstrapGate>
            <BrowserRouter>
              <ThemeProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <SnackbarProvider>
                    <Router />
                  </SnackbarProvider>
                </LocalizationProvider>
              </ThemeProvider>
            </BrowserRouter>
          </BootstrapGate>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
